'use client';

import React, { memo, useMemo } from 'react';
import { Box, Card, Text } from '@chakra-ui/react';
import CardHeader from './components/CardHeader';
import { IBranch } from '@/_types';
import NumberToPrice from '@/_components/NumberToPrice';
import { useCustomLocale } from '@/_hooks/useCustomLocale';
import { IProduct } from '@/entities/product/model/types';

const ProductCard = ({
  product,
}: {
  product: Partial<IProduct>;
}) => {
  const currentLocale = useCustomLocale();

  const totalDiscount = useMemo(() => {
    let result = 0;
    if (product?.discounts?.length) {
      result = product?.discounts?.reduce((acc, cur) => {
        return acc + cur?.discount_price;
      }, 0);
    }

    return result;
  }, [product.discounts]);

  // Extract brand id from pathname if on brand page
  return (
    <Card.Root
      rounded={16}
      cursor={'pointer'}
      border='1px solid #F4F4F4'
      boxShadow='0px 4px 20px 0px #0000000F'
    >
      <Card.Header
        px={{ base: 2, lg: 4 }}
        pt={{ base: 2, lg: 4 }}
      >
        <CardHeader totalDiscount={totalDiscount} product={product} />
      </Card.Header>
      <Card.Body
        pb={3}
        px={{ base: 2, lg: 4 }}
        minH='78px'
        position='relative'
        pt={{ base: 3, lg: 4 }}
      >
        <NumberToPrice
          textProps={{
            fontSize: { lg: 'xl' },
            lineHeight: 1,
            fontWeight: 600,
            color: 'price',
          }}
          spanProps={{
            fontSize: { lg: 'xl' },
            lineHeight: 1,
            fontWeight: 600,
            color: 'price',
          }}
          value={(product?.out_price || 0) + totalDiscount}
        />
        {totalDiscount !== 0 && (
          <Box
            textDecor={'line-through'}
            fontSize={{ base: 'xs', lg: 'sm' }}
            color='text.muted'
            mt={1}
          >
            <NumberToPrice
              textProps={{
                lineHeight: 1,
                fontWeight: 600,
              }}
              spanProps={{
                lineHeight: 1,
                fontWeight: 600,
              }}
              value={product?.out_price || 0}
            />
          </Box>
        )}
        <Text
          fontSize={{ base: 'sm', lg: 'md' }}
          height={{ base: 'auto', lg: 10 }}
          lineHeight={1.2}
          fontWeight={500}
          lineClamp={2}
          color='text'
          mt={1}
        >
          {product?.title?.[currentLocale]}
        </Text>
        {/* <Text
          display={{ base: 'none', lg: 'block' }}
          color='text.muted'
          lineHeight='18px'
          opacity={product?.weight ? 1 : 0}
        >
          {product?.weight ? `${product?.weight} ${t('grams')}` : '.'}
        </Text> */}
      </Card.Body>
      <Card.Footer
        px={{ base: 2, lg: 4 }}
        pb={{ base: 2, lg: 4 }}
        flexDir={'column'}
        justifyContent={'flex-start'}
        alignItems={'start'}
        color='product_button.text'
      >

      </Card.Footer>
    </Card.Root>
  );
};

export default memo(ProductCard);
